// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1EwE1R0glNXskC {\n  display: block;\n  position: relative;\n  align-items: center;\n  align-self: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n.YUT9a3oIGhvVfV {\n  color: #172b4d;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  line-height: 20px;\n  margin-top: 24px;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n}\n._2WfxcJTXRsP8vU {\n  color: #172b4d;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 20px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trelloViewsImage": "_1EwE1R0glNXskC",
	"calloutHeaderText": "YUT9a3oIGhvVfV",
	"calloutContentText": "_2WfxcJTXRsP8vU"
};
export default ___CSS_LOADER_EXPORT___;
